/**
 * PATH: packages/job-hub/src/jobs/qa/itpPreviewRemoved.ts
 * FILE_ID: JOBHUB-QA-ITP-PREVIEW-REMOVED-001
 * PURPOSE: Mark a preview photo block the user cleared so a saved ITP does not fill it again.
 */
export function markPreviewPhotosCleared(block: Element): void {
  block.setAttribute('data-preview-cleared', '1')
}

export function previewPhotosCleared(article: Element): boolean {
  return article.querySelector('.photos')?.getAttribute('data-preview-cleared') === '1'
}
